<template>
  <div class="red-packet1-dialog">
    <div class="red-packet1-content" slot="custom">
      <nd-button class="withdraw" @click="handleButtonClick" 
                 v-stat="{
                   id: 50022,
                   args: {
                     target: 'NEW_PERSON', // 新人活动
                     step: data.nextStep,
                     position: 1,
                     status: 1
                   },
                 }"
      >前往认证</nd-button>
      <div class="activity-detail" @click="handleTextButtonClick">
        活动详情 >
      </div>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isLogin: Boolean
  },
  methods: {
    open () {
      this.visible = true
      setKey('NEW_COMER_1_SHOW_TIME', Date.now())
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    handleButtonClick () {
      if (this.data.nextStep) {
        // this.$report({
        //     id: 10124,
        //     args: {
        //         target: 3,
        //         status: this.data.couponDetailType
        //     }
        // })
        this.$router.push({
          path: '/authentication/id'
        })
      } else {
        this.$router.push('/user/login')
      }
    }, 

    handleTextButtonClick () {
      this.$report({
        id: 10124,
        args: {
          target: 3,
          status: this.data.couponDetailType
        }
      })
      this.$router.push({
        path: '/newHumanity/detail',
        query: {
          loanPlatform: 'TMD',
          activeType: this.data.activeType,
          open: 1
        }
      })
    },
    show () {
      this.isLogin && setKey('NEW_COMER_1_SHOW_TIME', Date.now())
      this.$report({
        id: 50021,
        args: {
          visible: 1,
          target: 'NEW_PERSON', // 免息活动
          step: this.data.nextStep,
          status: 1
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.red-packet1-dialog {
    .red-packet1-content {
        width: 620px;
        height: 750px;
        border-radius: 30px;
        position: relative;
        background: url('./pop_xinyinghu01@2x.png');
        background-size: 100%;
        .activity-detail {
            position: absolute;
            bottom: 0px;
            left: 0px;
            right: 0px;
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 53px;
        }
        .withdraw {
            position: absolute;
            top: 540px;
            width: 440px;
            height: 80px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 50px;
        }
    }
}
</style>
